import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "./assets/styles/styles.scss";
import "react-toastify/dist/ReactToastify.css";

// router
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import { Router } from "react-router";
import { history } from "./utils/History";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router history={history}>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
